import { useEffect } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { useMuteStore, useTicketMute, useTicketMuteBusy } from '../model/mute-store';
import styles from './TicketMuteButton.module.css';

export const TicketMuteButton: React.FC<{
  ticketId: string;
  className?: string;
  likelyVisible?: boolean;
}> = ({ ticketId, className, likelyVisible = false }) => {
  const load = useMuteStore((s) => s.load);
  const toggle = useMuteStore((s) => s.toggle);
  const entry = useTicketMute(ticketId);
  const saving = useTicketMuteBusy(ticketId);

  useEffect(() => {
    void load(ticketId);
  }, [ticketId, load]);

  if (!entry) {
    return likelyVisible ? (
      <span className={cn(styles.placeholder, className)} aria-hidden />
    ) : null;
  }
  if (!entry.canMute) return null;

  const muted = entry.muted;

  return (
    <button
      type="button"
      className={cn(styles.button, muted && styles.muted, className)}
      onClick={() => void toggle(ticketId)}
      disabled={saving}
      aria-pressed={muted}
      title={
        muted
          ? 'Уведомления по заявке приглушены: приходят молча, без звука, всплывашек и писем'
          : 'Приглушить: уведомления по заявке будут приходить без звука, всплывашек и писем'
      }
    >
      {muted ? <BellOff size={14} aria-hidden /> : <Bell size={14} aria-hidden />}
      {muted ? 'Приглушено' : 'Приглушить'}
    </button>
  );
};
